import { useSpring, easings } from '@react-spring/web';
import { useEffect } from 'react';

import { AnimatedDiv } from '@/utils/animated-div';
import { classNames } from '@/utils/classnames';

interface BackgroundProgressAnimationProps {
  display?: boolean;
  className?: string;
  duration?: number;
}

export const BackgroundProgressAnimation = ({
  display,
  className,
}: BackgroundProgressAnimationProps) => {
  const [progressSpring, progressApi] = useSpring(() => ({
    width: 0,
    opacity: 1,
    progress: 0, // Track progress from 0 to 1 for color interpolation
  }));

  useEffect(() => {
    if (display) {
      // Start progress animation - animate width from 0% to 100% and progress from 0 to 1
      progressApi.start({
        from: { width: 0, progress: 0 },
        to: { width: 100, progress: 1 },
        config: { duration: 4000, easing: easings.easeInOutCubic },
        delay: 1,
      });
    } else {
      // Exit animation
      progressApi.start({
        opacity: 0,
        config: { duration: 400 },
        delay: 1,
      });
    }
  }, [display, progressApi]);

  if (!display) return null;

  return (
    <>
      <div className={classNames('absolute inset-0 bg-special-background-modal', className)} />
      <AnimatedDiv
        className={classNames('absolute inset-y-0 left-0 bg-token-gray-200', className)}
        style={{
          width: progressSpring.width.to((w) => `${w}%`),
          opacity: progressSpring.opacity,
        }}
        role="progressbar"
        aria-label="Transaction progress"
      />
    </>
  );
};
